<template>
  <div @mouseenter="cellEnter" @mouseleave="cellLeave">
    <div class="className flex space-between vertical pointer" v-if="!isEdit" @click.prevent="cellClick">
      <span>{{editContent}}</span>
      <icon name="edit" :scale="1.5" v-if="isHover" />
    </div>
    <div class="className flex space-between vertical" v-else>
      <el-input v-model="editContent" size="mini" onkeydown="if(event.keyCode ==32)return false" />
      <i class="el-icon-check class-name-icon pointer" @click.prevent="save"></i>
      <i class="el-icon-close class-name-icon pointer" @click.prevent="cancel"></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.className {
  width: 100%;
  height: inherit;
  padding: 5px;
}
.class-name-icon {
  // vertical-align: middle;
  font-size: 14px;
  line-height: 2em;
  margin: 0 5px;
}
.table-operations {
  width: 100%;
  height: 100%;
  display: flex;
}
.operation-icon {
  font-size: 20px;
  margin: 0 5px;
}
</style>

<script>
export default {
  props: {
    value: String || Number // 双向绑定数据
  },
  data() {
    return {
      isHover: false,
      isEdit: false
    }
  },
  computed: {
    editContent: {
      get() {
        return this.value
      },
      set(editContent) {
        this.$emit('input', editContent)
      }
    }
  },
  methods: {
    // 点击保存方法
    save() {
      this.$emit('save')
      this.isEdit = false
    },
    // 取消方法
    cancel() {
      this.isEdit = false
      this.$emit('cancel')
    },
    // hover单元格
    cellEnter() {
      this.isHover = true
    },
    // leave单元格
    cellLeave() {
      this.isHover = false
    },
    // 点击单元格
    cellClick() {
      this.isEdit = true
    }
  }
}
</script>
